import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';
import { getEnv } from './env';

export type TypedSupabaseClient = SupabaseClient<Database>;

let instance: TypedSupabaseClient | null = null;

/** localStorage key holding the Supabase session (read by the pre-render script in index.html). */
export function authStorageKey(appKey: string): string {
  return `LUVIA_TOUR:${appKey}:auth`;
}

/**
 * Single browser-wide Supabase client. Only the publishable key is used here; the
 * service-role key lives exclusively in the admin-users Edge Function.
 */
export function getSupabase(): TypedSupabaseClient {
  if (instance) return instance;
  const env = getEnv();
  instance = createClient<Database>(env.supabaseUrl, env.supabaseKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Implicit flow: password-reset links work even when the reset was requested
      // from another browser (e.g. a manager sending it for an employee).
      flowType: 'implicit',
      storageKey: authStorageKey(env.appKey),
    },
    realtime: {
      params: { eventsPerSecond: 20 },
    },
  });
  return instance;
}
